import { FormControl, Input as MuiInput, Typography } from "@mui/material";

import React, { forwardRef, memo } from "react";
import InputError from "../input-error";

const Textarea = forwardRef<HTMLTextAreaElement, any>(
  ({ error, fullWidth = true, label, sx, ...rest }, ref) => {
    return (
      <FormControl fullWidth={fullWidth}>
        {label && (
          <Typography
            fontWeight={500}
            mb={1}
            variant="body1"
            sx={{ fontSize: "14px", fontWeight: "600" }}
          >
            {label}
          </Typography>
        )}
        <MuiInput
          multiline
          inputRef={ref}
          sx={{
            background: (theme) => theme.bg.paper,
            borderRadius: 2,
            fontSize: "small",
            padding: "12px 16px",
            border: (theme: any) =>
              error ? "1px solid #E84933" : `1px solid ${theme.palette.secondary[200]}`,
            "&.Mui-focused": {
              border: (theme) =>
                error ? "1px solid #E84933" : `1px solid ${theme.palette.primary.main} !important`,
            },
            ...sx, // Merge the sx prop here
          }}
          disableUnderline
          {...rest}
        />
        {error && <InputError message={error} />}
      </FormControl>
    );
  }
);

Textarea.displayName = "Textarea";

export default memo(Textarea);
